import { render, staticRenderFns } from "./top-banner.vue?vue&type=template&id=05d61dba&scoped=true&"
import script from "./top-banner.vue?vue&type=script&lang=js&"
export * from "./top-banner.vue?vue&type=script&lang=js&"
import style0 from "./top-banner.vue?vue&type=style&index=0&id=05d61dba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d61dba",
  null
  
)

export default component.exports